import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../ui/Dialog/DialogContent";
import DialogActions from "../../../ui/Dialog/DialogActions";
import FacilityInfoForm from "../RoomInfoForm";
import Checkbox from "../../../ui/Checkbox";

const styles = theme => ({
  dialog: {
    width: "476px"
  }
});

const AddRoomModal = ({
  open,
  handleClose,
  createRoom,
  isCreatingRoom,
  createdRoom,
  classes,
  history,
}) => {
  const [formData, updateFormData] = React.useState(null);
  const [checked, setChecked] = React.useState(false);

  const onConfirm = () => {
    createRoom(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  React.useEffect(() => {
    if (createdRoom && createdRoom.success) {
      updateFormData(null);
      handleClose();

      if (checked) {
        history.push(`/work/app/rooms/${createdRoom.id}`);
      }
    }
  }, [createdRoom]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Добавить помещение</DialogTitle>
        <DialogContent>
          <FacilityInfoForm
            onFormChange={updateFormData}
            disabled={isCreatingRoom}
          />
        </DialogContent>
        <DialogActions>
          <Checkbox
            checked={checked}
            label="Открыть форму для редактирования"
            handleChange={() => setChecked(!checked)}
          />
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingRoom}
            disabled={isCreatingRoom}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(AddRoomModal));
